import React from "react";
import { cn } from "@penmate/react-shared/lib/utils";

// The illustration's own motif — a paper plane traveling a dashed circle —
// as the search-in-flight signal. It is the wait step's hero on the purple
// field; while the search runs the plane circles, and it rests in place (the
// animation pauses) once the search has finished or a match is up.
export const PlaneOrbit = ({ active, className }: { active: boolean; className?: string }) => (
  <svg className={cn("h-24 w-24", className)} viewBox="0 0 96 96" fill="none" aria-hidden="true">
    <circle
      cx="48"
      cy="48"
      r="38"
      stroke="hsl(var(--teal-bright))"
      strokeWidth="2"
      strokeDasharray="2 9"
      strokeLinecap="round"
      opacity="0.7"
    />
    <g className={cn("pm-orbit", !active && "pm-orbit--paused")}>
      {/* Plane sits on the top of the circle, nose pointing along the orbit. */}
      <g transform="translate(48 10) scale(1.15) translate(-12 -12)">
        <path d="M2 21l21-9L2 3v7l15 2-15 2v7z" fill="hsl(var(--teal-bright))" />
        <path d="M23 12L2 12" stroke="hsl(var(--teal))" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M2 21l21-9-6-.3-15 2.3v7z" fill="hsl(var(--teal))" opacity="0.55" />
      </g>
    </g>
  </svg>
);
